import React, { Component } from 'react';

import Select from 'react-select';
import 'react-select/dist/react-select.css';

import { Link } from 'react-router-dom';

import { Task } from './../../classes/task.class';

const LEFT_SWIPE_TO_ACTION = -90;
const RIGHT_SWIPE_TO_ACTION = 90;

class TaskComponent extends Component { 
    constructor(props) {
        super(props);
        this.state = {
            task: props.task,
            value: [],
            tags: props.tags,
            width: null,
            left: 0,
            xStart: null,
            inputWidth: 0,
            showEditTags: false
        }
        
        if( this.state.task.tags !== null) {
            this.state.task.tags.forEach(tag => {
                Object.defineProperties(tag, {
                    value: { value: tag.name },
                    label: { value: tag.name }
                });
            });
        }

        console.log(this.state.tags);

    }

    componentDidMount() {
        this.setState({width: document.getElementById(`task-${this.state.task.id}`).clientWidth});
        this._resize();
    }

    _handleDelete(id) {
        this.props.deleteTask(id);
    }

    _handleInputName(e) {
        let name = e.target.value;

        this.setState(prevState => ({
            task: {
                ...prevState.task,
                name: name
            }
        }));

        this._resize();
    }

    _resize() {
        let nameLength = this.state.task.name.length <= 0 ? 2 : this.state.task.name.length;
        this.setState({inputWidth: (nameLength * 18)+ 'px'});
    }

    _handleUpdate(task) {
        if(task !== undefined) {
            this.props.updateTask( task );    
            return;
        }
        this.props.updateTask( this.state.task );
    }

    handleInputTag = (value) => {
        let newTags = value.map(tag => {
            console.log(tag);
            if(!tag.hasOwnProperty('id')) {
                Object.defineProperties(tag, {
                    id: {
                        value: `@${tag.value}`,
                        enumerable: true
                    },
                    name: {
                        value: tag.value,
                        enumerable: true
                    }
                });
            }

            return tag;
        });

        console.log("NEW TAGS", newTags);

        this._updateTaskWithTag(newTags);
    }

    _updateTaskWithTag(tags) {
        let taskCopy = JSON.parse(JSON.stringify(this.state.task));
        //make changes to ingredients
        taskCopy.tags = tags;//whatever new ingredients are

        this.setState({
                task:taskCopy 
        }); 

        this._handleUpdate(taskCopy);
    }

    _markToday() {
        let oldTags = this.state.task.tags;
        console.log("OLD", oldTags);
        if(oldTags.filter(tag => tag.id === 3).length > 0) {
            oldTags = oldTags.filter(tag => tag.id !== 3);
            this._updateTaskWithTag(oldTags);
            return 
        }
        let tags = this.state.tags.filter(tag => tag.id === 3);

        console.log(tags);

        this._updateTaskWithTag(oldTags.concat(tags));
    }

    _finishTask() {
        let taskCopy = new Task(JSON.parse(JSON.stringify(this.state.task)));

        taskCopy.progress = 100;
        taskCopy.tags = this.state.task.tags;

        this.setState({task: taskCopy});

        this._handleUpdate(taskCopy);
    }

    _handleTouchStart(e) {
        this.setState({xStart: e.touches[0].clientX});
    }

    _handleTouchMove(e) {

        if(this.state.xStart > e.touches[0].clientX) {
            this.setState({left: -(this.state.xStart - e.touches[0].clientX)});
            
        }
        else if(this.state.xStart < e.touches[0].clientX) {
            this.setState({left: Math.abs(this.state.xStart - e.touches[0].clientX)});
        }
    }

    _handleOnTouchEnd(e) {
        console.log(this.state.left);
        if(this.state.left < LEFT_SWIPE_TO_ACTION) {
            if(this.state.task.progress < 100) {
                this._finishTask();
            } else if(this.state.task.progress >= 100) {
                this._handleDelete(this.state.task.id);
            }

            
            console.log("DELETE");
        }
        console.log(this.state.left);
        if(this.state.left > RIGHT_SWIPE_TO_ACTION) {
            console.log("TO DAILY");
            this._markToday();
        }
        this.setState({left: 0});
    }

    _handleToggleTag() {
        this.setState({showEditTags: !this.state.showEditTags});
    }

    _handleProgressChange(progress) {
        let taskCopy = new Task(JSON.parse(JSON.stringify(this.state.task)));

        taskCopy.progress = progress;
        taskCopy.tags = this.state.task.tags;

        this.setState({task: taskCopy});
        this._handleUpdate(taskCopy);
        //document.getElementById(`progress-btn-${taskCopy.id}`).checked = false;
    }

    _handleFocus(e) {
        e.target.select();
    }

    render() {
        let task = this.state.task;
        let taskTags = task.tags.map(tag => { 
            console.log(tag.code);
            if(tag.id !== 3) {
                return <li>{tag.name}</li>; 
            }
        });
        let classes = task.progress >= 100 ? 'task--done' : `task--progress-${task.progress}`;
        
        let bookmarked = task.tags.filter(tag => tag.id === 3).length > 0 ? <span className="bookmark"></span> : '';

        const { selectedOption } = this.state;
        //const value = selectedOption && selectedOption.value;
        const value = this.state.value;

        let style = {
            left : this.state.left
        }

        let progressIcon = '💤';

        if(task.progress == 25) {
            progressIcon = '👋';
        }else if(task.progress == 50 ) {
            progressIcon = '🤙';
        }else if (task.progress == 75) {
            progressIcon = '🏃‍';
        }else if(task.progress == 100) {
            progressIcon = '🏁';
        }

        return(
            
            <li id={"task-"+task.id} 
                className={'task  '+ classes}
                onTouchStart={this._handleTouchStart.bind(this)}
                onTouchMove={this._handleTouchMove.bind(this)}
                onTouchEnd={this._handleOnTouchEnd.bind(this)}
                
            >

            <button className="task__btn  task__btn--bookmark">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bookmark"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path></svg>
            </button>

            <button className="task__btn  task__btn--finish" style={{display: task.progress < 100 ? '' : 'none'}}  >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" class="feather feather-check-circle"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
            </button>

            <button className="task__btn  task__btn--delete" style={{display: task.progress < 100 ? 'none' : ''}} >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-delete"><path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"></path><line x1="18" y1="9" x2="12" y2="15"></line><line x1="12" y1="9" x2="18" y2="15"></line></svg>
            </button>

            <article style={style}>
                <input 
                    className="task__name" 
                    style={{width: this.state.inputWidth}} 
                    type="text" 
                    autocomplete="off"
                    value={task.name} 
                    onChange={this._handleInputName.bind(this)} 
                    onFocus={this._handleFocus.bind(this)}
                    onBlur={this._handleUpdate.bind(this, this.state.task)}/>

                <ul className="task__tags">{taskTags}</ul>
                
                
                <ul className="task__action-list">
                    <li>
                        <button className="task__action-list__btn" onClick={this._handleToggleTag.bind(this)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" class="feather feather-tag"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7" y2="7"></line></svg>
                        </button>
                    </li>
                    <li>
                        <button className={bookmarked ? 'task__action-list__btn  task__action-list__btn--marked' : 'task__action-list__btn'} onClick={this._markToday.bind(this)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" class="feather feather-bookmark"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path></svg>
                        </button>
                    </li>

                    
                </ul>

                <input type="checkbox" className="task__progress-btn" id={'progress-btn-'+task.id}/>
                <label for={'progress-btn-'+task.id}>
                    {progressIcon}
                    <ul className="task__progress--action"> 
                        <li>
                            <button onClick={this._handleProgressChange.bind(this, 0)}>💤</button>
                        </li>
                        <li>
                            <button onClick={this._handleProgressChange.bind(this, 25)}>👋</button>
                        </li>
                        <li>
                            <button onClick={this._handleProgressChange.bind(this, 50)}>🤙</button>
                        </li>
                        <li>
                            <button onClick={this._handleProgressChange.bind(this, 75)}>🏃‍</button>
                        </li>
                        <li>
                            <button onClick={this._handleProgressChange.bind(this, 100)}>🏁</button>
                        </li>
                    </ul>
                </label>
                

                <div className="task__edit-tags" style={{right: this.state.showEditTags ? '0' : '-100%'}}>
                    <Select.Creatable
                            name="form-field-name"
                            value={task.tags}
                            onChange={this.handleInputTag.bind(this)}
                            multi
                            options={this.state.tags}
                            placeholder="choose tags"
                        />
                </div>


                <span className="task__priority"></span>
                <span className="task__progress" style={{width: task.progress+'%'}}></span>

            </article>


            
                
            </li>
        );
    }
}


export default TaskComponent;


// WEBPACK FOOTER //
// src/components/task/task.component.js